import { Component, SimpleChanges } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { delay, finalize } from 'rxjs';
import { AllMinuteRequest, AllMinuteResponse } from '../files-clients/sub-page/minutes/interface/minute-request.interface';
import { MinuteRequestService } from '../files-clients/sub-page/minutes/service/minute-request.service';

@Component({
  selector: 'app-view-minutes',
  templateUrl: './view-minutes.component.html',
  styleUrls: ['./view-minutes.component.scss']
})
export class ViewMinutesComponent {
  minutas: PageResult<AllMinuteResponse>;
  booleanFlag: boolean = false;
  booleanText: boolean = false;

  public dashboardFilter: AllMinuteRequest;
  
  constructor(private minuteService: MinuteRequestService) {
    this.minutas = {
      ...this.minutas,
      results: [],
    };

    this.dashboardFilter = {page:1, size:10, search:'', status:7, sortOrder:'' };
   }

  ngAfterViewInit(): void {

  }

  ngOnInit() {
    this.getAllMinutes();
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  async receiveFilterGeneral(event: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      search: event,
    };

    this.getAllMinutes();
  }

  public receiveChangeEstadoFilter(event: string | null) {
    
    this.dashboardFilter = {
      ...this.dashboardFilter,
      status: Number.parseInt(event)
    };

    this.getAllMinutes();
  }

  public receiveProviderPaginationChange(changePagination: any) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      page: changePagination.page,
      size: changePagination.size,
    };

    this.getAllMinutes(); 
  }

  receiveChangeSortingOrder(sortOrder: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sortOrder: sortOrder
    }
    this.getAllMinutes(); 
  }

  public getAllMinutes() {
    this.booleanFlag = true
    this.booleanText = true
    this.minuteService
      .getAllMinutes(this.dashboardFilter)
      .pipe(
        delay(1500),
        finalize(() => { this.booleanFlag = false }),
      )
      .subscribe({
        next: (response) => {
          if (response.results.length == 0) {
            this.booleanText = false
          }
          this.minutas = response;
          this.booleanFlag = false
        },
        error: (e) => {
          //que ocurre cuando hay un error
          console.log(e)
        },
        complete: () => {
          this.booleanFlag = true
        }
      }); 
  }

}